{
  "name": "secure-messages-fe",
  "version": "1.0.1",
  "scripts": {
    "watch": "ng test",
    "build": "ng build",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --code-coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.0",
    "@angular/cdk": "20.0.1",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/material": "20.0.1",
    "@angular/platform-browser": "^20.0.0",
    "@angular/platform-browser-dynamic": "^20.0.0",
    "@angular/router": "^20.0.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.0.0",
    "@angular/cli": "^20.0.0",
    "@angular/compiler-cli": "^20.0.0",
    "@sparbanken-syd/auth-backend": "^2.3.4",
    "@sparbanken-syd/meeting-planner-be": "^1.0.0",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^20.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^20.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^20.0.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^20.0.0",
    "@types/jasmine": "~5.1.7",
    "angular-eslint": "^19.3.0",
    "eslint": "^9.23.0",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.3",
    "stylelint": "^16.16.0",
    "stylelint-config-sass-guidelines": "^12.1.0",
    "stylelint-config-standard-scss": "^14.0.0",
    "typescript": "~5.8.2",
    "typescript-eslint": "^8.27.0"
  }
}
